import React from "react";
import {
  View,
  SafeAreaView,
  KeyboardAvoidingView,
  Platform,
  StyleSheet
} from "react-native";
import { colors, layout } from "@/constants";

interface ScreenLayoutProps {
  children: React.ReactNode;
}

export default function ScreenLayout({ children }: ScreenLayoutProps) {
  const content = (
    <View style={styles.wrapper}>
      <View style={styles.container}>{children}</View>
    </View>
  );

  // For web, use simple layout - let scroll into view handle keyboard //
  // Native platforms: Use KeyboardAvoidingView
  return (
    <SafeAreaView
      style={[styles.safeArea, { backgroundColor: colors.surface }]}
    >
      {Platform.OS === "web" ? (
        <View style={styles.keyboardView}>{content}</View>
      ) : (
        <KeyboardAvoidingView
          style={styles.keyboardView}
          behavior={Platform.OS === "ios" ? "padding" : "height"}
        >
          {content}
        </KeyboardAvoidingView>
      )}
    </SafeAreaView>
  );
}

const styles = StyleSheet.create({
  safeArea: {
    flex: 1
  },
  wrapper: {
    flex: 1,
    alignItems: "center"
  },
  keyboardView: {
    flex: 1,
    width: "100%"
  },
  container: {
    flex: 1,
    width: "100%",
    maxWidth: layout.maxWidth,
    minWidth: layout.minWidth
  }
});
